<template>
  <div id="FuelTicketDetail">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Fuel Ticket Detail (All)</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
          <div class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportEnrichReports()">
              <i class="fp-export"></i> Compare
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'fuelTicketDetail'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'fuelTicketDetail'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Fuel Ticket Detail"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "FuelTicketDetail",
  metaInfo() {
            return {title: "Fuel Ticket Detail | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Location", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Ticket Date',
          field: 'ticket_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "MM/DD/YYYY", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Non Bill Code',
          field: 'non_bill_code',
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Non Bill Code", // placeholder for filter input
              filterDropdownItems: [], // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:true
      },
      {
          label: 'Tkt Sts',
          field: 'status',
          filterable: true,
          fpFieldType:"option",
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Ticket Status", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Entered(E)','Processed(P)','Billed(B)'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
    //   {
    //       label: 'Pump',
    //       field: 'pump_id',
    //       fpFieldType:"text",
    //       filterable: false,
    //       hidden:true,
    //   },

      {
          label: 'Billable',
          field: 'is_billable',
          filterable: true,
          fpFieldType:"option",
          hidden:true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Billable", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Yes','No'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Unit',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Product',
          field: 'item',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Item", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Item Category',
          field: 'item_category',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Item Category", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Qty',
          field: 'quantity',
          filterable: true,
          fpFieldType:"integer",
          type: 'number',
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Quantity", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Unit Cost',
          field: 'cost',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit Cost", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Unit Price',
          field: 'price',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit Price", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Total Cost',
          field: 'tot',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit Price", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false,
      },
    //   {
    //       label: 'Total Cost',
    //       field: 'total',
    //       fpFieldType:"integer",
    //       hidden:false,
    //       type:'number',
    //       filterable: true,
    //       filterOptions: {
    //           enabled: false, // enable filter for this column
    //           placeholder: "Total Cost", // placeholder for filter input
    //           filterValue: '', // initial populated value for this filter
    //           trigger: "enter" //only trigger on enter not on keyup
    //       }
    //   },
      {
          label: 'Total Revenue',
          field: 'total_revenue',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Total Revenue", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:true,
      },
      {
          label: 'Tax',
          field: 'tax',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Tax", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Total Invoiced',
          field: 'ticket_total',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Total Invoiced", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Margin Pct',
          field: 'margin_pct',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Margin Pct", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Base Cost',
          field: 'base_cost',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Base Cost", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
      {
          label: 'Ttl Base Cost',
          field: 'ttl_base_cost',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Ttl Base Cost", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Mark-up Margin Pct',
          field: 'markup_margin_pct',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Mark-up Margin Pct", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Equipment Pool',
          field: 'pool',
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Equipment Pool", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Customer',
          field: 'customer',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Customer", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },

      {
          label: 'Invoice',
          field: 'invoice_number',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Invoice", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'RA Agreement',
          field: 'ra_agreement',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "RA Agreement", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Ticket Bill Date',
          field: 'ticket_bill_dt',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "MM/DD/YYYY", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:true
      },
      {
          label: 'Inventory Update Date',
          field: 'inv_update_dt',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "MM/DD/YYYY", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:true
      },
      {
          label: 'Inventory Year',
          field: 'year',
          filterable: false,
          sortable:false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Inventory Year", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Inventory Period',
          field: 'inv_period',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Inventory Period", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Create User',
          field: 'create_user',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Create User", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Create Date',
          field: 'created_at',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "MM/DD/YYYY", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Current Reading',
          field: 'vehicle_read',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Current Reading", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'LTD Reading',
          field: 'ltd_read',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Ltd Reading", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Reading UOM',
          field: 'uom',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Reading UOM", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Reference',
          field: 'ref',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Reference", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
       {
          label: 'Equipment Type',
          field: 'equip_type',
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Equipment Type", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
       {
          label: 'Equipment Type Description',
          field: 'equip_type_desc',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Equipment Type Description", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Permit IRP',
          field: 'permit_no',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Permit IRP", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Permit IRP Description',
          field: 'permit_desc',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Permit IRP Description", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Station Name',
          field: 'station_name',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Station Name", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Station City',
          field: 'station_city',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Station City", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Station State',
          field: 'station_state',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Station State", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'PO Number',
          field: 'po_number',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "PO Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Driver ID',
          field: 'driver_id',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Driver ID", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Card Number',
          field: 'card_number',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Card Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Ticket Time',
          field: 'ticket_time',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Ticket Time", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Create Time',
          field: 'create_time',
          filterable: false,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Create Time", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Facility City',
          field: 'facility_city',
          filterable: true,
          fpFieldType:"option",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Facility City", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
      {
          label: 'Facility Prov/ State Code',
          field: 'facility_code',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Card Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
      {
          label: 'Facility Postal/ Zip Code',
          field: 'zip_code',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Facility Prov/ Zip code", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
      {
          label: 'Invoice Date',
          field: 'invoice_date',
          fpFieldType:"custom_date",
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "MM/DD/YYYY", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Ticket Seq Number',
          field: 'ticket_seq_no',
          filterable: true,
          fpFieldType:"text",
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Ticket Seq Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'fuel_ticket_detail') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{

    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/fuel-ticket-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action,


        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue" || self.action == "compare-with-enrich" || self.action == "compare-with-enrich_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" || self.action == "compare-with-enrich" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {
                if (data.content.row != undefined) {
                self.rows = data.content.row;
                }
                self.totalRecords = data.content.totalRecords;
            }


           }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'fuel-ticket-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/FuelTicketDetailReport.vue